<template>
	
  <div class="control">
    <div class="c-icon">
      <span :class="icon"/>
    </div>
    <div v-if="isTemperature" class="c-input">
      {{ isTemperature ? $functions.temperature(modelValue, isCelsius) : modelValue }}
      {{ isTemperature ? unit : "" }}
    </div>
    <div v-else-if="isPercentage" class="c-input">
      {{ modelValue }}%
    </div>
    <div v-else-if="isTime" class="c-input">
      {{ time }}
    </div>
    <div v-else class="c-input"> 
      {{ modelValue }}
    </div>
    <div class="c-commands p-d-flex p-jc-center p-ai-stretch">
      <i :class="['pi','pi-minus',{'disabled': min==null || Number(modelValue)<=min}]" @pointerdown="press(false)" @pointerup="leave(false)" @pointercancel="leave(false)" @pointerleave="leave(false)"/>
      <Divider layout="vertical" />
      <i :class="['pi','pi-plus',{'disabled': max==null || Number(modelValue)>=max}]" @pointerdown="press(true)" @pointerup="leave(true)" @pointercancel="leave(true)" @pointerleave="leave(true)"/>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: ['modelValue', 'icon','isTemperature','isTime','isPercentage','min','max'],
    data() {
        return {
          normalpress: false,
          longpressTimeout: null,
          longpressInterval: null,
          isIncrement: false,
          initialValue: null
        };
    },
    computed: {
      ...mapGetters({
        personaltoken: 'userdata/personaltoken',
        unit: 'userdata/unit',
        isCelsius: 'userdata/isCelsius',
      }),
      step: function() {
        return this.isTemperature ? 10 : 1;
      },
      time: function() {
        if(this.isTime) {
          let time = this.modelValue;
          var hours = Math.floor(time / 60);
          time = time - hours * 60;
          var minutes = Math.floor(time);
          return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
        } else {
          return null;
        }
      }
    },
    watch: {
      'min': function () { this.update() },
      'max': function () { this.update() },
    },
    created() {
      this.initialValue = this.modelValue;
    },
    methods: {
      increment() {
        if(this.max == null || this.modelValue>=this.max) {
          return;
        }
        this.update(this.step);
      },
      decrement() {
        if(this.min == null || this.modelValue<=this.min) {
          return;
        }
        this.update(-this.step);
      },
      update(s) {
        if(s==null) {
          s = 0;
        }
        
        let newValue;
        if(this.isTemperature) {
          newValue = Math.round(Number(this.modelValue)/10)*10 + s;
        } else {
          newValue = Math.round(Number(this.modelValue)) + s;
        }

        if(this.min == null || this.max == null) {
          newValue = this.initialValue;
        } else if(newValue < this.min) {
          newValue = this.min;
        } else if(newValue > this.max) {
          newValue = this.max;
        }

        if(!newValue) {
          newValue = 0;
        }

        if(s!=0) {
          this.$emit('update:modelValue', newValue );
        }
      },
      press(isIncrement) {
        this.normalpress = true;
        this.isIncrement = isIncrement;
        this.longpressTimeout = setTimeout(() => {
          this.startLongPress();
        }, 500 );
      },
      startLongPress() {
        this.longpressInterval = setInterval(() => {
          if(this.isIncrement) {
            this.increment();
          } else {
            this.decrement();
          }
        }, this.isTime ? 10 : 200 );
      },
      leave() {
        if(this.normalpress) {
          clearTimeout(this.longpressTimeout);
          this.longpressTimeout = null;
          clearTimeout(this.longpressInterval);
          this.longpressInterval = null;
          if(this.isIncrement) {
            this.increment();
          } else {
            this.decrement();
          }
          this.normalpress = false;
        }
      },
    }
}
</script>

<style >

</style>